import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/addLineDialogStyle';
import { makeStyles } from '@material-ui/core';
import { BodyS } from 'components/Typography/Typography';

//  @ts-ignore
const useStyles = makeStyles(styles);

interface ISearchRowProps {
	text: string;
}

const SearchRow = (props: ISearchRowProps) => {
	const classes = useStyles();
	const { text } = props;

	return (
		<div className={classes.menuItemWrapper}>
			<BodyS color="primary-light" disableMargin>
				{text}
			</BodyS>
		</div>
	);
};

export default SearchRow;
